export * from '#src/models/relatedPersons/utils.ts'
